<h5 class="title mb-4 text-primary">{{'sessao_ii'|translate}}</h5>
<div class="row g-4 mb-4">
    <div class="col-lg-12"
        *ngIf="mdcService.isVisible(['mdc_17'], mdcService.formData.i_1! == 2 && mdcService.formData.mdc_3! >= 6, null)">
        <div class="form-group">
            <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_17')}}<span class="text-danger">&nbsp;*</span></label>
            <ul class="custom-control-group g-3 align-center flex-wrap">
                <li *ngFor="let item of mdcService.mdc17options">
                    <div class="custom-control custom-checkbox custom-control-pro no-control">
                        <input type="radio" class="custom-control-input required" id="mdc_17_{{item.id}}"
                            #mdc_17="ngModel" name="mdc_17" [(ngModel)]="mdcService.formData.mdc_17"
                            value="{{item.value}}" [attr.data-msg]="('obrigatorio_error_msg' | translate)" required>
                        <label class="custom-control-label" for="mdc_17_{{item.id}}">{{item.name}}</label>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="col-lg-12">
        <div class="form-group">
            <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_18')}}<span class="text-danger">&nbsp;*</span></label>
            <div class="form-control-wrap">
                <select class="form-select" #mdc_18="ngModel" name="mdc_18" [(ngModel)]="mdcService.formData.mdc_18"
                    [attr.data-msg]="('obrigatorio_error_msg' | translate)" required>
                    <option value="">{{'selct_msg'|translate}}</option>
                    <option *ngFor="let item of mdcService.mdc18options" [value]="item.value">
                        {{item.name}}</option>
                </select>
            </div>
        </div>
    </div>
    <div class="col-lg-12" *ngIf="mdcService.isVisible(['mdc_19'], mdcService.formData.mdc_18! >= 5, null)">
        <div class="form-group">
            <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_19')}}<span class="text-danger">&nbsp;*</span></label>
            <div class="form-control-wrap">
                <textarea class="form-control form-control-sm" rows="1" #mdc_19="ngModel" name="mdc_19"
                    [(ngModel)]="mdcService.formData.mdc_19" [attr.data-msg]="('obrigatorio_error_msg' | translate)"
                    required></textarea>
            </div>
        </div>
    </div>
    <div class="col-lg-12" *ngIf="mdcService.isVisible(['mdc_20'], mdcService.formData.mdc_3! >= 15, null)">
        <div class="form-group">
            <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_20')}}<span class="text-danger">&nbsp;*</span></label>
            <ul class="custom-control-group g-3 align-center flex-wrap">
                <li *ngFor="let item of mdcService.mdc20options">
                    <div class="custom-control custom-checkbox custom-control-pro no-control">
                        <input type="radio" class="custom-control-input required" id="mdc_20_{{item.id}}"
                            #mdc_20="ngModel" name="mdc_20" [(ngModel)]="mdcService.formData.mdc_20"
                            value="{{item.value}}" [attr.data-msg]="('obrigatorio_error_msg' | translate)" required>
                        <label class="custom-control-label" for="mdc_20_{{item.id}}">{{item.name}}</label>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>